import React, {useEffect, useState} from 'react';
import Button from "reactstrap/es/Button";
import {Col, Row} from "reactstrap";
import {vs3BetButtons, vs4BetButtons, vs5BetButtons, vsOrButtons} from "./playButtonInit";

const colStyle = {
    width: "100%",
    display: "flex",
    padding: "1px",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4px"
}

const allOneOnOneButtons = [
    {title: "vs OR", buttons: vsOrButtons},
    {title: "vs 3BET", buttons: vs3BetButtons},
    {title: "vs 4BET", buttons: vs4BetButtons},
    {title: "vs 5BET", buttons: vs5BetButtons}
];

const OneOnOneButtonsController = (props) => {
    const [filters, setFilters] = useState(props.filters);

    function buttonIsDisabled(buttonData) {
        if (filters) {
            return !buttonData.myPos.includes(filters.myPosition)
        } else {
            return true
        }
    }

    return (
        <div style={{marginBottom: "20px"}}>
            {allOneOnOneButtons.map((buttonArray, index) => {
                return (
                    <Row key={"btn-row-" + index} style={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px"}}>
                        <Col xl={2} md={2} sm={2} lg={3} xs={2} xxl={2}>
                            <div className="text-center">
                                <strong className="text-white text-center"
                                        style={{fontSize: "0.8rem"}}>{buttonArray.title}</strong>
                            </div>
                        </Col>
                        <Col>
                            <Row style={{display: "flex", alignItems: "center", justifyContent: "left", width: "100%"}}>
                                {buttonArray.buttons.map((buttonData, index) => {
                                    return (
                                        <Col
                                            key={buttonData.id} xl={2} md={2} sm={2} lg={2} xs={2} xxl={2}
                                            style={colStyle}>
                                            <Button
                                                disabled={buttonIsDisabled(buttonData)}
                                                onClick={e => updateFilters(buttonData)} size="sm"
                                                color={buttonIsDisabled(buttonData) ? "secondary" : "success"}
                                                style={{width: "100%"}}
                                            >
                                                {buttonData.label}
                                            </Button>
                                        </Col>
                                    )
                                })}
                            </Row>

                        </Col>
                    </Row>
                )
            })}
        </div>
    );

    function updateFilters(buttonData) {
        props.updateFilters(buttonData.filters, true)
    };
};

export default OneOnOneButtonsController;